import ReactCountryFlag from "react-country-flag";
import styles from "./ShipmentDistribution.module.scss";
import LoadingSkeleton from "../../../../shared/LoadingSkeleton/index.jsx";
import React, { useState } from "react";
import GetInTouchPopup from "./GetInTouchPopup";
import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { useSelector } from "react-redux";
import { transformData } from "@helpers/profileHelper";
import { getIntelUrl } from "@utils/intelUrl";
import { createCountryRedirectUrl, getRedirectProfileType } from "@core/global/global-country-functions";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { useLocation } from "react-router-dom";
import { getUserCurrentPlan } from "@utils/utils";
import { redirectingProfileEnum } from "@core/global/global-country-dictionary";
import { CountryCodeOneToOneMap, DATASET_TYPE_MAPPING, getDatasetMirrorSortGroup, getShipmentDatasetDisplayName } from "@core/dictionary/global";

const ShipmentDistribution = ({ profileType, profileId, category, profileName, viewShipmentsEvent = () => null, profileRedirectionId = "", companyName, shipmentDistribution, shipmentDistributionLoader }) => {
  const { search: searchUrlParams } = useLocation();
  const [showGetInTouchPopup, setShowGetInTouchPopup] = useState(false);
  const [notifyCountry, setNotifyCountry] = useState("");
  const { isParentSubs } = useSelector((state) => state.companyProfile);
  const userCurrentPlan = JSON.parse(localStorage.getItem("userCurrentPlan"));
  const tab = new URLSearchParams(searchUrlParams).get("tab");
  let isFreightForwarder = useSelector((state) => state?.logisticsProfile?.isFreightForwarder);
  let mergeId = new URLSearchParams(searchUrlParams).get("mergedID");

  const handleViewClick = (isSubscribed, country, trade_direction, key = "US Imports") => {
    if (!isSubscribed) {
      setShowGetInTouchPopup(true);
      setNotifyCountry(transformData(key, true, false));
      return;
    }
    sessionStorage.removeItem("selectedCountry");
    let payloadCategory = getRedirectProfileType(category);
    let redirectUrl = createCountryRedirectUrl(country.toLowerCase(), trade_direction);
    if (!!isFreightForwarder && payloadCategory === redirectingProfileEnum.nvocc.key) {
      payloadCategory = redirectingProfileEnum.freightForwarder.key;
    }
    let url = getIntelUrl() + `${redirectUrl}?redirectingFrom=${profileType}&redirectingProfile=${payloadCategory}&redirectingProfileIds=${profileRedirectionId}&profileName=${profileName}&profileId=${profileId}`;
    if (isParentSubs) {
      url += `&isSubsidiaryIncluded=${isParentSubs}`;
    }
    if (mergeId) {
      url += `&isMerged=true&mergedID=${mergeId}`;
      url += `&companyName=${companyName}`;
    }
    if (tab) {
      url += `&tab=${tab}`;
    }
    window.open(url, "_blank");
    viewShipmentsEvent();
  };

  return (
    <div className={styles.distributionContainer}>
      <p className={styles.heading}>Shipments distribution across data sources {getUserCurrentPlan(userCurrentPlan?.user_active_plan)}</p>
      {shipmentDistributionLoader ? (
        <LoadingSkeleton lines={5} lineHeight="20px" width="100%" shape="rectangle" />
      ) : shipmentDistribution && shipmentDistribution?.length > 0 ? (
        <div className={styles.countriesList}>
          {[...shipmentDistribution]
            ?.sort((a, b) => Number(b.isSubscribed) - Number(a.isSubscribed) || Number(getDatasetMirrorSortGroup(a.countryCode, a.trade_direction)) - Number(getDatasetMirrorSortGroup(b.countryCode, b.trade_direction)) || b.doc_count - a.doc_count)
            ?.map(({ key = "", doc_count = 0, isSubscribed, countryCode, country, trade_direction }) =>
              doc_count ? (
                <div key={key.split(" ").join("_")} className={`${styles.country} ${shipmentDistribution?.length === 2 && shipmentDistribution.find((item) => item.key === "multicountry") && key === "multicountry" ? "d-none" : ""}`}>
                  {doc_count ? (
                    <div className={styles.left}>
                      {country.toLowerCase() === globalCountryDetailsDictionary.multi_country.country_small ? (
                        <>
                          <span className="material-symbols-outlined globe-image">public</span>
                          <span className={styles.countryName}>Multi Country</span>
                        </>
                      ) : (
                        <>
                          {countryCode === "global" ? <span className="material-symbols-outlined globe-image-side-drawer">public</span> : CountryCodeOneToOneMap[countryCode.toLowerCase()] ? <ReactCountryFlag countryCode={CountryCodeOneToOneMap[countryCode.toLowerCase()]} svg /> : <ReactCountryFlag countryCode={countryCode} svg />}
                          <span className={styles.countryName}>
                            {getShipmentDatasetDisplayName(country, trade_direction)}
                            {DATASET_TYPE_MAPPING[`${countryCode?.toLowerCase()}_${trade_direction?.toLowerCase()?.endsWith("s") ? trade_direction?.toLowerCase()?.slice(0, -1) : trade_direction?.toLowerCase()}`]}
                          </span>
                        </>
                      )}
                      {!isSubscribed ? <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg`} className={styles.boltImage} /> : null}
                    </div>
                  ) : (
                    <></>
                  )}
                  {doc_count ? (
                    <span onClick={() => handleViewClick(isSubscribed, countryCode, trade_direction, key)} className={styles.right}>
                      View {doc_count !== doc_count ? `${doc_count.toLocaleString()} of ${doc_count.toLocaleString()}` : doc_count.toLocaleString()} shipments
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              ) : null
            )}
        </div>
      ) : null}
      {showGetInTouchPopup ? <GetInTouchPopup showGetInTouchPopup={showGetInTouchPopup} handleGetInTouchClose={() => setShowGetInTouchPopup(false)} profileType={profileType} notifyCountry={notifyCountry} blockAccessType={"dataset"} /> : null}
    </div>
  );
};

const MemoizedShipmentDistribution = React.memo(ShipmentDistribution);

export default MemoizedShipmentDistribution;
